export default "__VITE_ASSET__D8ttt$lb__"